export default __webpack_public_path__ + "static/media/picture3.d5a0ea62.png";